import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
  textareaTheme,
} from '../../../../lib';


const formName = 'Office & Door Signs';

const defaultValues = {
  'Quantity': '',
  'Modular-or-custom': '',
  'Size': '',
  'Material': '',
  'Content': '',
  'Match-existing-signage': '',
  'Installation-required': '',
};

const fields = [
  'Quantity',
  'Modular-or-custom',
  'Size',
  'Material',
  'Content',
  'Match-existing-signage',
  'Installation-required',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <Radio
        radioId='Modular-or-custom'
        radioName='Modular-or-custom'
        legend='Modular or custom?'
        options={[
          { value: 'modular', label: 'Modular' },
          { value: 'custom', label: 'Custom' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputTheme}
      />

      <Radio
        radioId='Material'
        radioName='Material'
        legend='Material?'
        options={[
          { value: 'acrylic', label: 'Acrylic' },
          { value: 'metal', label: 'Metal' },
          { value: 'lamacoid', label: 'Lamacoid' },
        ]}
        register={register}
        formState={formState}
        columns={1}
        theme={radioTheme}
      />

      <Textarea
        textareaId='Content'
        textareaName='Content'
        register={register}
        formState={formState}
        label='Content'
        theme={textareaTheme}
      />

      <Radio
        radioId='Match-existing-signage'
        radioName='Match-existing-signage'
        legend='Are we matching existing signage?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Installation-required'
        radioName='Installation-required'
        legend='Installation required?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
